import { GET_INTERNATIONAL_STATE_REQUEST, GET_INTERNATIONAL_STATE_SUCCESS, GET_INTERNATIONAL_STATE_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalState = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_STATE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalState`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_STATE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_STATE_ERROR,
                payload: error.response,
            });
        })
}

